// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoader_container__9yoUF","loader":"PageLoader_loader__KjgAq","rotate":"PageLoader_rotate__U0Oq2"};